export default __webpack_public_path__ + "static/luke@2x-9604d20e56fb7df8b5279566e5bd20f3.jpg";